import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsSalesOriginStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    status?: TypographyProps;
}

export const SalesOriginStyles: OrderDetailsSalesOriginStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        as: "h2",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
    status: {
        size: 14,
    },
};

const styles = SalesOriginStyles;

const OrderDetailsSalesOrigin = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.properties.salesOrigin) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="OrderDetailsSalesOrigin">
                {translate("Sales Origin")}
            </Typography>
            <Typography {...styles.status} aria-labelledby="OrderDetailsSalesOrigin">
                {order.properties.salesOrigin}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsSalesOrigin,
    definition: {
        displayName: "Order Details Sales Origin",
        allowedContexts: ["OrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
